import {MAIN_BAND_ID} from "../../../constants";

export const canManageCollectorBands = (auth) => auth?.band?.id === MAIN_BAND_ID;

export const toProfiles = (data = {}) => (
  data.profiles?.length
    ? data.profiles
    : (data.band ? [{band: data.band, isDefault: true}] : [])
);

export const getBandName = (bands = [], bandId) => (
  bands.find((band) => band.id === bandId)?.name || bandId
);

export const getBandLabel = (band = {}) => (
  band.name || `밴드명 없음 (${band.id || "알 수 없음"})`
);

export const summarizeProfileBands = (profiles) => {
  const orderedProfiles = [...(profiles || [])]
    .sort((a, b) => Number(Boolean(b?.isDefault)) - Number(Boolean(a?.isDefault)));
  const names = orderedProfiles
    .map((profile) => profile?.band?.name)
    .filter(Boolean);

  if (names.length === 0) return "없음";
  if (names.length === 1) return names[0];
  if (names.length === 2) return `${names.join(", ")} (${names.length})`;
  return `${names.slice(0, 2).join(", ")}, ... (${names.length})`;
};
